// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2567":"b4e9c58e1a7d6d44","2888":"997a8d7e947a9d30","4793":"982a2a40a0080442"}[chunkId] + ".css";
};